import {Component, Input} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {InfoDialogComponent} from "../info-dialog/info-dialog.component";

@Component({
    selector: 'app-info-button',
    templateUrl: './info-button.component.html',
    standalone: false
})
export class InfoButtonComponent {
    @Input() infoText: string;

    constructor(private dialog: MatDialog) {}

    openInfoDialog() {
        this.dialog.open(InfoDialogComponent, {
            disableClose: true,
            position: { top: '100px' },
            data: { infoText: this.infoText }
        }).afterClosed();
    }
}
